//@flow
const ActionTypes = {
  PUSH_NOTIFICATION: 'PUSH_NOTIFICATION',
  DROP_NOTIFICATION: 'DROP_NOTIFICATION'
};

export default ActionTypes;
